const _403_dp = (externalBaseUrl: string) => ({
	structure: {
		type: 'Page',
		styleId: '_403_dp_style',
		id: '_403_dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zs',
				dataQuery: '#dataItem-ivs730zs1',
				layout: {
					width: 701,
					height: 81,
					x: 203,
					y: 379,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs730zt',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zu',
				dataQuery: '#dataItem-ivs730zu1',
				layout: {
					width: 381,
					height: 76,
					x: 207,
					y: 482,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs730zv',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'style-ivs76437',
				id: 'comp-ivs730zv1',
				dataQuery: '#dataItem-ivs730zv2',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					width: 198,
					height: 56,
					x: 203,
					y: 599,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs730zw',
				componentType: 'wysiwyg.viewer.components.SiteButton',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs73100',
				dataQuery: '#dataItem-ivs731001',
				layout: {
					width: 339,
					height: 235,
					x: 174,
					y: 100,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs73102',
				componentType: 'wysiwyg.viewer.components.WPhoto',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zs',
				dataQuery: '#dataItem-ivs730zs1',
				layout: {
					width: 320,
					height: 39,
					x: 0,
					y: 208,
					scale: 0.8084127123905273,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 18,
							originalValue: 265,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-ivs730zu',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'mobile_propItem-ivs730zt',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zu',
				dataQuery: '#dataItem-ivs730zu1',
				layout: {
					width: 277,
					height: 78,
					x: 21,
					y: 265,
					scale: 0.6948499742213815,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 29,
							originalValue: 372,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-ivs730zv1',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'mobile_propItem-ivs730zv',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'style-ivs76437',
				id: 'comp-ivs730zv1',
				dataQuery: '#dataItem-ivs730zv2',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					width: 204,
					height: 56,
					x: 53,
					y: 372,
					scale: 0.863837598531476,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 0,
							originalValue: 428,
							type: 'BOTTOM_PARENT',
							locked: true,
							targetComponent: '_403_dp',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs730zw',
				componentType: 'wysiwyg.viewer.components.SiteButton',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs73100',
				dataQuery: '#dataItem-ivs731001',
				layout: {
					width: 272,
					height: 196,
					x: 24,
					y: -23,
					scale: 1.0,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 35,
							originalValue: 208,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-ivs730zs',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs73102',
				componentType: 'wysiwyg.viewer.components.WPhoto',
			},
		],
		dataQuery: '#_403_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			width: 980,
			height: 675,
			x: 0,
			y: 0,
			scale: 1.0,
			rotationInDegrees: 0.0,
			fixedPosition: false,
		},
		componentType: 'mobile.core.components.Page',
	},
	data: {
		document_data: {
			_403_dp: {
				type: 'Page',
				id: '_403_dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: '403',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: '403',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			'dataItem-ivs730zs1': {
				type: 'StyledText',
				id: 'dataItem-ivs730zs1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#EF7E6B"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">Hold Up There...</span></span></span></h4>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs730zu1': {
				type: 'StyledText',
				id: 'dataItem-ivs730zu1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">Looks like you don&rsquo;t have permission to view this page.</span></span></span></p>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs730zv2': {
				type: 'LinkableButton',
				id: 'dataItem-ivs730zv2',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Back ',
				link: '#dataItem-iwis06js',
			},
			'dataItem-ivs731001': {
				type: 'Image',
				id: 'dataItem-ivs731001',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '403.png',
				uri: '035244_9795292eb93245db90aa31852ea0afbf~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
				crop: {
					x: 27,
					y: 21,
					width: 346,
					height: 239,
				},
			},
			'dataItem-iwis06js': {
				type: 'ExternalLink',
				id: 'dataItem-iwis06js',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: externalBaseUrl,
				target: '_self',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs76437': {
				type: 'TopLevelStyle',
				id: 'style-ivs76437',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#EF7E6B',
						'boxShadowToggleOn-shd': 'false',
						brd: '#EF7E6B',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#EF7E6B',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-ivs730zt': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1.0,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-ivs730zv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-ivs730zt': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-ivs730zv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-ivs730zw': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-ivs73102': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
		},
	},
	title: '403',
	pageUriSEO: '403',
})

export default _403_dp
